module.exports = __webpack_public_path__ + "media/controllers/city_icon-dff12ef0a02a91c560fe7ac7d06a44bf.svg";